export const CONTRACT_SERVICE_TYPES = {
  JOB: 'job',
  RECRUITMENT_PROCESS_OUTSOURCING: 'recruitment_process_outsourcing',
  REVERSE_MARKETING: 'reverse_marketing',
};
